module.exports = __webpack_public_path__ + "img/pay-1.52708186.png";